import withErrorCheck from "../CheckError";
import server from "../Server";

export type GetPlayerFormPayload = { pid: number };
export type PlayerFormRow = {
  player_id: number;
  name: string | null;
  outcome_streak: string | null; // space-separated 'W D L ...' in chronological order
  ratings: string | null;        // space-separated '8.2 7.5 ...' in chronological order
};

export const GetPlayerForm = async ({ pid }: GetPlayerFormPayload): Promise<PlayerFormRow | null> => {
  const response = await server
    .from("player_form_view")
    .select(["player_id", "name", "outcome_streak", "ratings"].join(","))
    .eq("player_id", pid)
    .maybeSingle();

  const row = withErrorCheck<PlayerFormRow | null>(response as any) || null;
  return row;
};
